module.exports = __webpack_public_path__ + "static/media/img_4.81f8d879.JPG";